import { takeLatest, call, put } from 'redux-saga/effects';
import {
    getAllSuccess,
    getAllFailure,
    getMySuccess,
    getMyFailure,
    updateAllSuccess,
    updateAllFailure,
    getRolesSuccess,
    getRolesFailure,
    createRoleSuccess,
    createRoleFailure,
    deleteRoleSuccess,
    deleteRoleFailure,
} from './slice';
import requestHandler from '../../../utils/requestHandler';
import { logoutRequest } from '../auth/authSlice';

const API_BASE = `${process.env.REACT_APP_SERVER_API}api/permissions`;
// Roles CRUD is served under /api/roles (getRoles/createRole/deleteRole).
// NOTE: not /api/permissions/roles — that collides with GET /api/permissions/:role.
const ROLES_API = `${process.env.REACT_APP_SERVER_API}api/roles`;

function* getAllSaga() {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const response = yield call(requestHandler, API_BASE, {
            method: 'GET',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
            },
        });

        yield put(getAllSuccess(response));
    } catch (error) {
        yield put(getAllFailure(error?.response?.message || error.message));
    }
}

function* getMySaga(action) {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const { role } = action.payload;
        const response = yield call(requestHandler, `${API_BASE}/${role}`, {
            method: 'GET',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
            },
        });

        yield put(getMySuccess(response));
    } catch (error) {
        yield put(getMyFailure(error?.response?.message || error.message));
    }
}

function* updateAllSaga(action) {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const response = yield call(requestHandler, API_BASE, {
            method: 'PUT',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ permissions: action.payload }),
        });

        yield put(updateAllSuccess(response));
    } catch (error) {
        yield put(updateAllFailure(error?.response?.message || error.message));
    }
}

function* getRolesSaga() {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const response = yield call(requestHandler, ROLES_API, {
            method: 'GET',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
            },
        });

        yield put(getRolesSuccess(response));
    } catch (error) {
        yield put(getRolesFailure(error?.response?.message || error.message));
    }
}

function* createRoleSaga(action) {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const response = yield call(requestHandler, ROLES_API, {
            method: 'POST',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(action.payload),
        });

        yield put(createRoleSuccess(response));
    } catch (error) {
        yield put(createRoleFailure(error?.response?.message || error.message));
    }
}

function* deleteRoleSaga(action) {
    try {
        const authToken = localStorage.getItem('item');
        if (!authToken) {
            yield put(logoutRequest());
            return;
        }

        const { role } = action.payload;
        const response = yield call(requestHandler, `${ROLES_API}/${role}`, {
            method: 'DELETE',
            headers: {
                'Authorization': authToken,
                'Content-Type': 'application/json',
            },
        });

        yield put(deleteRoleSuccess(response));
    } catch (error) {
        yield put(deleteRoleFailure(error?.response?.message || error.message));
    }
}

function* saga() {
    yield takeLatest('permissions/getAllRequest', getAllSaga);
    yield takeLatest('permissions/getMyRequest', getMySaga);
    yield takeLatest('permissions/updateAllRequest', updateAllSaga);
    yield takeLatest('permissions/getRolesRequest', getRolesSaga);
    yield takeLatest('permissions/createRoleRequest', createRoleSaga);
    yield takeLatest('permissions/deleteRoleRequest', deleteRoleSaga);
}

export default saga;
